import { createElement } from "@max/max";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { AmountType, PrizeType, LayoutType } from '@/types/shared';
import { MTNewDigitalDisplayStyle } from '@/utils/common';
import { IS_IOS, IS_ANDROID } from '@/hooks/useRequest';
import { convertCentsToYuan } from '@/utils/common';
import './index.scss';
const Price = ({ amount, amountType, rewardType, layoutType }) => {
    const isDiscount = amountType === AmountType.DISCOUNT;
    const isPoints = rewardType === PrizeType.POINTS;
    const currencyStyle = IS_IOS ? {
        marginTop: '32rpx'
    } : {};
    let amountFontSize = '60rpx';
    const isSmallLayoutType = layoutType === LayoutType.DOUBLE;
    let amountTop = IS_ANDROID ? '14rpx' : '6rpx';
    let finalAmount = amount;
    if (!isPoints && !isDiscount) {
        const res = convertCentsToYuan(Number(amount));
        finalAmount = res.integerPart;
    }
    else if (isDiscount) {
        // 折扣金额除以10
        const discountValue = Number(amount) / 10;
        finalAmount = discountValue.toFixed(1);
    }
    const amountLength = String(finalAmount || '').length;
    const wrapperStyle = {};
    if (IS_IOS) {
        wrapperStyle.alignItems = 'center';
    }
    else {
        wrapperStyle.alignItems = 'flex-end';
    }
    if (IS_ANDROID) {
        wrapperStyle.marginTop = '-16rpx';
        wrapperStyle.marginBottom = '12rpx';
    }
    if (layoutType === LayoutType.TRIPLE) {
        wrapperStyle.marginTop = IS_ANDROID ? '-12rpx' : '-2rpx';
        wrapperStyle.marginBottom = IS_ANDROID ? '10rpx' : '2rpx';
        amountTop = IS_ANDROID ? amountTop : isPoints ? '2rpx' : '6rpx';
    }
    if (isSmallLayoutType) {
        wrapperStyle.marginTop = IS_ANDROID ? '0rpx' : '10rpx';
        wrapperStyle.marginBottom = IS_ANDROID ? '10rpx' : '0rpx';
        // amountTop = IS_ANDROID ? amountTop : '-10rpx';
        if (isPoints) {
            amountTop = IS_ANDROID ? amountTop : '2rpx';
            if (amountLength === 3) {
                amountFontSize = '50rpx';
                amountTop = IS_ANDROID ? '20rpx' : '10rpx';
                wrapperStyle.marginTop = IS_ANDROID ? '0rpx' : '0rpx';
            }
            else if (amountLength > 3) {
                amountFontSize = '40rpx';
                amountTop = IS_ANDROID ? '24rpx' : '12rpx';
            }
        }
        else if (!isPoints && !isDiscount && amountLength > 3) {
            // 不是积分、不是折扣
            amountFontSize = '50rpx';
            amountTop = IS_ANDROID ? '18rpx' : '10rpx';
        }
    }
    const amountStyle = {
        fontSize: amountFontSize,
        top: amountTop
    };
    const symbolStyle = IS_IOS ? {
        marginTop: '32rpx'
    } : {};
    return <View className="amount-wrapper" style={wrapperStyle}>
      {!isDiscount && !isPoints && <Text style={{
                ...symbolStyle,
                ...MTNewDigitalDisplayStyle
            }} className="currency">¥</Text>}
      <Text style={{
            ...MTNewDigitalDisplayStyle,
            ...amountStyle
        }} className="amount">{finalAmount}</Text>
      {isDiscount && !isPoints && <Text style={currencyStyle} className="currency">折</Text>}
      {isPoints && <Text style={currencyStyle} className="currency-point">积分</Text>}
    </View>;
};
export default Price;
